<template>
  <div
    class="page-header bg-secondary m-0 p-3 border-bottom d-flex align-items-center overflow-hidden"
  >
    <p
      class="page-title mr-4 mb-0 ellipsis"
    >
      {{ pageTitleAttributes.name }}
    </p>
    <p
      :class="['label px-2 mb-0', getClassForLabel]"
    >
      {{ pageTitleAttributes.state }}
    </p>
    <div
      class="page-options d-flex"
    >
      <slot />
      <template v-for="(tab, index) in tabs">
        <div
          class="d-flex align-items-center px-2 stepper"
          :class="[isDisabled(tab) ? 'disabled' : '', isActive(tab)]"
          :key="index"
          @click="updateStepper(tab)"
          :data-test="`${tab.dataTest}`"
        >
          <div
            class="avatar avatar-sm mr-2"
            :class="stepperClass"
          >
            {{ index + 1 }}
          </div>
          <div id="navigation-text">
            <div>{{ tab.subtitle }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import dateHelper from '@/core/mixins/dateHelper';
import campaignMixin from '@/core/mixins/campaignHelper';

export default {
  name: 'BaseWizardHeader',
  mixins: [dateHelper, campaignMixin],
  components: {
  },
  props: {
    title: {
      type: String,
      default: 'Basic info',
    },
    activeIndex: {
      type: Number,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    disableOverride: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'contentItems',
      'activeCreatives',
    ]),
    ...mapState('account', {
      avatarColour: 'avatarColour',
    }),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_NEW_CAMPAIGN,
      campaignTypes.GET_CAMPAIGN_MAX_END_DATE,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CONTENT_ITEMS_WITH_MISSED_CREATIVES,
    ]),
    stepperClass() {
      return `avatar-${this.avatarColour}`;
    },
    pageTitleAttributes() {
      return this.getPageTitleAttributes();
    },
    getClassForLabel() {
      return this.getLabelClass();
    },
  },
  methods: {
    isDisabledForCampaignInThePast(tab) {
      return tab.disabledWhenCampaignInThePast && (this.GET_CAMPAIGN_MAX_END_DATE === null || this.isDateInThePast(this.GET_CAMPAIGN_MAX_END_DATE));
    },
    isDisabledForContentType(tab) {
      return this.contentItems.some((contentItem) => contentItem.contentItemProperties
        && contentItem.contentItemProperties.contentType
        && !contentItem.contentItemProperties.contentType.includes('html') && this.activeIndex <= 2 && tab.index > 2);
    },
    isDisabledBecauseOfCreatives(tab) {
      return tab.index > 2 && (this.activeCreatives.length === 0 || this.GET_CONTENT_ITEMS_WITH_MISSED_CREATIVES.length > 0);
    },
    isDisabled(tab) {
      if (this.GET_IS_NEW_CAMPAIGN && tab.index !== 0) return true;
      if (this.activeIndex > tab.index) return false;
      if (this.isDisabledForContentType(tab)
        || this.isDisabledForCampaignInThePast(tab)
        || this.isDisabledBecauseOfCreatives(tab)) return true;
      return !this.disableOverride && this.disabled;
    },
    isActive(tab) {
      if (this.activeIndex === tab.index) return 'active';
      return '';
    },
    updateStepper(tab) {
      if (!this.isDisabled(tab)) {
        this.$emit('update-index', tab.index);
      }
    },
  },
};
</script>
<style scoped lang="scss">
#navigation-text {
  display: none;
}
.page-title {
  max-width: 40%;
  line-height: 2.5rem;
}
@media (min-width: 1330px) {
  #navigation-text {
    display: block;
  }
  .page-title {
    max-width: 30%;
  }
}
</style>
